import React from 'react';
import BracketButton from './BracketButton';
import { CTA_IMAGE } from '../mock/mock';

const CTA = () => {
  return (
    <section className="relative bg-black text-white overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={CTA_IMAGE}
          alt="Highway"
          className="w-full h-full object-cover opacity-45 grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-32 lg:py-44">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-[1.5px] bg-white/70" />
          <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/80">
            Ready When You Are
          </span>
        </div>
        <h2 className="big-display text-[64px] sm:text-[110px] lg:text-[160px] leading-[0.88]">
          Let’s Get
          <br />
          <span className="text-white/40">Rolling.</span>
        </h2>
        <p className="font-body text-white/80 text-base lg:text-lg leading-relaxed max-w-xl mt-8">
          Whether it’s a single hotshot run or a full-year contract, we’ll match your freight with the right rig and driver. Same-day quotes.
        </p>
        <div className="flex flex-wrap items-center gap-4 mt-10">
          <BracketButton to="/contact" variant="light">Request Quote</BracketButton>
          <BracketButton to="/services" variant="light">Explore Services</BracketButton>
        </div>
      </div>
    </section>
  );
};

export default CTA;
